import { useGetAllExamCentersQuery } from '@report/graphql';
import {
  FormSearchMultipleSelectionWithSelectAllOption,
  type FormSearchMultipleSelectionWithSelectAllOptionProps,
} from '@shared/components';
import { useMemo } from 'react';
import { type FieldValues } from 'react-hook-form';

type AllExamCenterSearchSelectionProps = Pick<
  FormSearchMultipleSelectionWithSelectAllOptionProps<FieldValues>,
  'name' | 'label' | 'placeholder' | 'sx'
>;

export default function AllExamCenterSearchSelection(
  props: Readonly<AllExamCenterSearchSelectionProps>,
) {
  const { name, label = 'Exam Center', placeholder, sx } = props;

  const { data: examCenterData, loading } = useGetAllExamCentersQuery();

  const options = useMemo(() => {
    const examCenters = [...(examCenterData?.reportGetAllExamCenters?.examCenters ?? [])];
    return examCenters
      .sort((a, b) => a.code.localeCompare(b.code))
      .map((examCenter) => ({
        label: examCenter.code,
        value: examCenter.code,
      }));
  }, [examCenterData]);

  return (
    <FormSearchMultipleSelectionWithSelectAllOption
      sx={sx}
      name={name}
      label={label}
      placeholder={placeholder}
      loading={loading}
      slotProps={{
        selectAllOption: {
          label: `Select All (${options.length})`,
        },
      }}
      options={options}
    />
  );
}
